import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-go-back",
  "use": "icon-go-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-go-back\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.0303 2.46967C17.3232 2.76256 17.3232 3.23744 17.0303 3.53033L8.56066 12L17.0303 20.4697C17.3232 20.7626 17.3232 21.2374 17.0303 21.5303C16.7374 21.8232 16.2626 21.8232 15.9697 21.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697L15.9697 2.46967C16.2626 2.17678 16.7374 2.17678 17.0303 2.46967Z\" fill=\"#7A8599\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol